module.exports = __webpack_public_path__ + "static/media/furikake.c007c90b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/furikake.jpg
// module id = 129
// module chunks = 0